import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bca53e9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ap-block" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "same-width mt-24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(["ap-icon ap-icon-edit", [_ctx.editing ? 'c-primary' : 'c-light']]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEditChange(true)))
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", { editing: _ctx.editing }, undefined, true)
    ]),
    _renderSlot(_ctx.$slots, "default", { editing: _ctx.editing }, undefined, true),
    (_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ap_button, {
            "btn-class": "btn-outline-primary lg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onEditChange(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('edit-block.btn.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ap_button, {
            "btn-class": "btn-primary lg",
            onClick: _ctx.onSaveInner
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('edit-block.btn.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}